import { Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core';
import { Quote } from '../../../models/quote';
import { faPlane, faTruckContainer } from '@fortawesome/pro-light-svg-icons';
import { CurrencyService } from '../../shared/services/currency.service';
import { DecodeDatePipe } from '../../shared/pipes/decode-date.pipe';
import { MoneyPipe } from '../../shared/pipes/money.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DatePipe } from '@angular/common';
import { MatCard } from '@angular/material/card';
import { Shipment } from '../../../models/shipment';
import { PackagingTypeEnum } from '../../../enum/packaging-type.enum';

@Component({
    selector: 'app-quote-card',
    templateUrl: './quote-card.component.html',
    styleUrls: ['./quote-card.component.scss'],
    imports: [MatCard, FontAwesomeModule, DatePipe, MoneyPipe, DecodeDatePipe]
})
export class QuoteCardComponent implements OnInit {

    static WIDTH = 175;
    static HEIGHT = 254;

    @Input()
    public shipment: Shipment;

    @Input()
    public quote: Quote;

    faTruckContainer = faTruckContainer;
    faPlane = faPlane;

    constructor(@Inject(LOCALE_ID) public locale: string, public currencyService: CurrencyService) {
    }

    ngOnInit(): void {
    }

    serviceIcon(): any {
        if (this.shipment && this.shipment.packagingType === PackagingTypeEnum.PALLET) {
            return this.faTruckContainer;
        }
        if (this.quote) {
            if (this.quote.serviceName.match(/ground/i) || this.quote.serviceName.match(/freight/i)) {
                return this.faTruckContainer;
            }
        }
        return this.faPlane;
    }

    showDiscount(): boolean {
        return (this.quote.discountPercent > 0);
    }

    discountPercentage(): string {
        return Math.ceil(this.quote.discountPercent).toString(10);
    }

    customerCurrencyPrefix(): string {
        return this.currencyService.prefix(this.quote.customer.currency);
    }

    customerCurrencySuffix(): string {
        return this.currencyService.suffix(this.quote.customer.currency);
    }

    showEstimatedTime(): boolean {
        return !!this.quote.estimatedDeliveryTime
            && this.quote.estimatedDeliveryTime !== '00:00'
            && this.quote.estimatedDeliveryTime <= '23:00';
    }

    showEstimatedDate(): boolean {
        return !!this.quote.estimatedDeliveryDate;
    }

    estimatedTime(): Date {
        if (this.quote.estimatedDeliveryTime) {
            const parts = this.quote.estimatedDeliveryTime.split(':');
            const date = new Date();
            date.setHours(parseInt(parts[0], 10));
            date.setMinutes(parseInt(parts[1], 10));
            return date;
        } else {
            return null;
        }
    }


}
